'use strict';
import React,{ Component } from 'react';
import ReactDom from 'react-dom';
import TagsComponent from '../commonComponents/TagsComponent';

class BootstrapTable extends React.Component{

    constructor(props){
        super(props);    
    }


    componentDidMount() {
        // this.renderTable()
    }
    renderTable() {        
        jQuery(`#${this.props.id}`).DataTable({
            responsive: true,
            orderClasses: false,
            language: {
                searchPlaceholder: 'Search...',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
            },
            columnDefs:[
                { "className": "dt-center", "targets": "_all" }
            ]
        });
    }

    componentWillMount(){
       

    }

    componentWillUnmount(){
        // var table = jQuery(`#${this.props.id}`).DataTable();
        // table.clear();
        // table.destroy();
    }

    render(){

        let that = this;
        
        // takes the following array configuration to render 
        //     let tableConfig = {
        //     "headers": [
        //         { "label": "Dimension", "name": "dimension" },
        //         { "label": "Include", "name": "include" },
        //         { "label": "Exclude", "name": "exclude" }
        //     ],
        //      "body": [
        //      each array is a single row of data 
        //     [{ "label": "abc", "content": "xyz" },
        //     { "label": "abc", "content": "xyz" },
        //     { "label": "abc", "content": "xyz" }],
        // ]
        // }

        // generates the table headers
        var tableHeaders = this.props.headers.map((element,i)=>{
            return (<th key={`${element.label}_${i}_header`} scope="col">{element.label}</th>);
        });

        //  generates the table rows
        var tableBody = this.props.body.map((element, i) => {
            
            element = Object.values(element);

            let table_rows = element.map((inner,x)=>{
                let temp_data = inner.content;
                return (<td key={`${inner.label}_${i}_${x}_cell`}>{temp_data}</td>);
            });

            return (<tr key={`row_${i}`}>{table_rows}</tr>);
        });

        return(
            <div>
               <table id={this.props.id} className="table table-bordered">
                    <thead className="thead">
                        <tr>
                            {tableHeaders}
                        </tr>
                    </thead>
                    <tbody>
                        {tableBody}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default BootstrapTable;